<div class="claim_body">
    <div class="top_panel">
        <h3>Assign Supervisor</h3>
        <span (click)="close()" class="close">
            <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="formarea">
        <form [formGroup]="assignUserForm">
            <div class="inputprt">

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Supervisor</mat-label>
                    <mat-select matNativeControl formControlName="assignedUserId">
                        <mat-option *ngFor="let item of agents"
                            value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                            item?.lastName)}}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="assignUserForm.controls['assignedUserId'].touched && assignUserForm.controls['assignedUserId'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                
                <!-- <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field> -->
            </div>
        </form>
        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <ng-container>
            <button mat-button type="button" class="sub-button" (click)="assignAgreement()"><span>Assign</span></button>
            <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
        </ng-container>
        </div>
    </div>
</div>